import { webApiDelete, webApiGet, webApiPost, webApiPut } from './request';

// export const loginApi = (request) => webApiPost('/login', { ...request })

// qlib
export const getcategoriesApi = () => webApiGet(`/api/category/getcategories`);
export const getQuestionsApi = (payload) => webApiPost('/api/question/getquestions', [...payload]);
export const loginApi = (request) => webApiPost('/api/user/login', { ...request });
export const getUserInfoApi = () => webApiGet(`/api/user/roles`);
export const getYearsApi = (key) => {
  return webApiGet(
    key
      ? `/reportapi/questionnaire/getQuestionnaireYears?reportkey=${key}`
      : '/api/questionnaire/getQuestionnaireYears'
  );
};
// export const questionnaireNamesApi = (payload) =>
//   webApiGet(`/questionnaire/getQuestionnaireNames${payload && '?year=' + payload?.year, '?client=' + payload?.client}`);
export const questionnaireNamesApi = (payload) => {
  let query = '';

  if (payload?.year || payload?.client) {
    query = `?${payload.year ? `year=${payload.year}` : ''}${payload.year && payload.client ? '&' : ''
      }${payload.client ? `client=${payload.client}` : ''} `;
  }

  return webApiGet(`/api/questionnaire/getQuestionnaireNames${query}`);
};
export const getQuestionsByIdApi = (payload) =>
  webApiPost(`/api/question/getQuestionsByQuestionnaireId?id=${payload}`);
export const updateProfileApi = (payload) => webApiPut(`/api/user/updateprofile`, { ...payload });
export const updatePasswordApi = (payload) => webApiPut(`/api/user/updatepassword`, { ...payload });

export const getSurveyQues = (id) => webApiGet(`/api/questionnaire/getSurveyQuestions?id=${id}`);
export const getSurveyQuesrkey = (payload) =>
  webApiGet(
    `/reportapi/questionnaire/getSurveyQuestions?id=${payload.id}&reportkey=${payload.rkey}`
  );
export const getSurveyFilter = (payload) =>
  webApiGet(
    `/${payload.type ? 'reportapi' : 'api'}/questionnaire/getSurveyFilters${payload.payload}`
  );
export const getSurveyChartData = (request) =>
  webApiPost(
    `/${request.reportkey ? 'reportapi' : 'api'}/questionnaire/${request.cqId != '' ? 'CrossTab' : 'getSurveyChartData'
    }`,
    {
      ...request
    }
  );
export const getUserProfile = (id) => webApiGet(`/api/user/getprofile?username=${id}`);
export const updatequestionnaireNamesApi = (payload) =>
  webApiPost(`/api/questionnaire/UpdateQuestionnaire`, { ...payload });
export const importDataApi = ({ file, title, year, id }) =>
  webApiPost(
    `/api/import/ImportData?${id && 'Id=' + id + '&'}${title && '&Title=' + title + '&'}${year && 'Year=' + year
    }`,
    file
  );
export const searchQuestionnaire = (id) =>
  webApiGet(`/api/questionnaire/Search?searchString=${id}`);

export const getExcelDownloadData = (request) =>
  webApiPost('/api/questionnaire/Download/Excel', { ...request });

export const getCrossTabQuestions = (payload) =>
  webApiGet(`/api/questionnaire/getCrossTabQuestions${payload.payload}`);
export const getCrossTabQuestionsReport = (payload) =>
  webApiGet(`/reportapi/questionnaire/getCrossTabQuestions${payload.payload}`);

export const clientNamesApi = (payload) =>
  webApiGet(`/api/questionnaire/getClients${payload ? '?year=' + payload : ''}`);

export const downloadImportFileApi = (payload) =>
  webApiGet(`/api/import/download-importfile?QuestionnaireId=${payload}`);

export const deleteQuestionnaireApi=(payload)=>
  webApiDelete(`/api/questionnaire/deletequestionnaire?QuestionnaireId=${payload}`)

// Title=${title}&
